const o = {
  name: "India",
  dimensions: { width: 20, height: 21 },
  content: `
    <g>
    <path d="M1 11.6925C1 16.4325 5.14 19.5725 9.88 19.5725C14.62 19.5725 19 16.4325 19 11.6925H1Z" fill="none" stroke="currentColor" stroke-width="1.8214" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M10.0898 1.6925C10.0898 1.6925 8.08984 4.1825 8.08984 6.6925C8.08984 7.8825 8.89984 8.6925 10.0898 8.6925C11.2798 8.6925 12.0898 7.8825 12.0898 6.6925C12.0898 4.1825 10.0898 1.6925 10.0898 1.6925Z" fill="none" stroke="currentColor" stroke-width="1.8214" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M10.0898 8.6925V11.6925" fill="none" stroke="currentColor" stroke-width="1.8214" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M6 15.6925C6.55228 15.6925 7 15.2448 7 14.6925C7 14.1402 6.55228 13.6925 6 13.6925C5.44772 13.6925 5 14.1402 5 14.6925C5 15.2448 5.44772 15.6925 6 15.6925Z" fill="currentColor" stroke="none"/>
    <path d="M10 15.6925C10.5523 15.6925 11 15.2448 11 14.6925C11 14.1402 10.5523 13.6925 10 13.6925C9.44772 13.6925 9 14.1402 9 14.6925C9 15.2448 9.44772 15.6925 10 15.6925Z" fill="currentColor" stroke="none"/>
    <path d="M14 15.6925C14.5523 15.6925 15 15.2448 15 14.6925C15 14.1402 14.5523 13.6925 14 13.6925C13.4477 13.6925 13 14.1402 13 14.6925C13 15.2448 13.4477 15.6925 14 15.6925Z" fill="currentColor" stroke="none"/>
    </g>
  `
};
export {
  o as India
};
